import { TableCell, styled } from '@mui/material';
export var StyledTableCell = styled(TableCell, {
    shouldForwardProp: function (prop) { return ![''].includes(String(prop)); },
})(function (_a) {
    var theme = _a.theme;
    return ({
    // '&:not(.MuiTableCell-head)': {
    //   fontWeight: `normal`,
    // },
    // '&:first-of-type': {
    //   '&:has(input[type="checkbox"]), &:has(.MuiIconButton-root) ': {
    //     paddingLeft: 8,
    //     '&:has(.MuiCollapse-root)': {
    //       paddingLeft: 0,
    //     },
    //   }
    // }
    });
});
//# sourceMappingURL=styled.js.map